import { Button, Stack, Typography, Box } from '@mui/material';
import { BasicCard } from 'components/BasicCard';
import { CenteredContent } from 'theme/elements/Content';
import { useAppSelector } from 'hooks/redux.hooks';
import { isLoading, getError } from 'state/reducers/auth.reducers';
import { ErrorText } from 'components/ErrorText';
import { Environment, AUTHENTICATION_URLS } from 'constants/api.constants';
import { selectTranslations } from 'state/reducers/translation.reducers';
import { globalEnvironment } from 'constants/global.constants';

export const Login = () => {
	const t = useAppSelector(selectTranslations);
	const error = useAppSelector(getError);
	const loading = useAppSelector(isLoading);

	const submitLoginForm = () => {
		window.location.replace(`${AUTHENTICATION_URLS[globalEnvironment]}`);
	};

	return (
		<CenteredContent>
			<Stack
				direction="column"
				spacing={2}
				sx={{
					backgroundImage: 'url(/images/login-background.svg)',
					backgroundRepeat: 'no-repeat',
					backgroundPosition: 'center',
					width: '100%',
					height: '100%',
				}}
			>
				<BasicCard
					styleObj={{
						margin: 0,
						position: 'absolute',
						top: '50%',
						left: '50%',
						transform: 'translate(-50%, -50%)',
						zIndex: 100,
						width: { xs: '100%', sm: 'auto' },
						height: { xs: '100%', sm: 'auto' },
						bgcolor: 'background.paper',
					}}
				>
					<Stack spacing={3}>
						<Stack spacing={2}>
							<Stack spacing={20} direction="column" sx={{ width: '100%' }}>
								<Stack spacing={3} direction="column" sx={{ width: '100%' }}>
									<Box>
										<img src={'/icons/brand-logo-color.webp'} />
									</Box>
									<Stack spacing={1} direction="column" sx={{ width: '100%' }}>
										<Typography variant="pageTitle">{t('login.title')}</Typography>
										<Typography variant="body4">{t('login.subtitle')}</Typography>
									</Stack>
								</Stack>
								<Button
									variant="contained"
									sx={{ padding: '20px' }}
									onClick={submitLoginForm}
									disabled={loading}
								>
									{t('button.login')}
								</Button>
							</Stack>
						</Stack>
						{error && <ErrorText error={error} />}
					</Stack>
				</BasicCard>
			</Stack>
		</CenteredContent>
	);
};
